import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { bindActionCreators, compose } from 'redux';
import { closeTicket } from '../../../actions/freshdesk-actions';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    '& h2': {
      margin: theme.spacing(2),
    },
  },
  popupBtnWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  popupButton: {
    margin: theme.spacing(1),
  },
}));

const CloseTicketPopup = ({
                            closeTicket,
                            closePopup,
                            setClosePopup,
                            ticketId,
                          }) => {
  const classes = useStyles();
  
  const closeButtonFunction = () => {
    closeTicket(ticketId);
    setClosePopup(false);
  };
  
  return (
    <>
      <Dialog maxWidth={'lg'} open={closePopup}>
        <DialogContent className={classes.dialogContent}>
          <h2>
            <FormattedMessage id="freshdesk.delete.ticket"
                              defaultMessage="Are you sure you want to close ticket #{ticketId}?"
                              values={{ ticketId: ticketId }} />
          </h2>
          <div className={classes.popupBtnWrapper}>
            <Button className={classes.popupButton} onClick={() => setClosePopup(false)}>
              <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
            </Button>
            <Button className={classes.popupButton} onClick={closeButtonFunction}>
              <FormattedMessage id="freshdesk.ticket.close.btn" defaultMessage="Close ticket" />
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

CloseTicketPopup.propTypes = {
  closeTicket: PropTypes.func,
  closePopup: PropTypes.func,
  setClosePopup: PropTypes.func,
  ticketId: PropTypes.number,
};

const decorate = compose(
  connect(
    null,
    dispatch => bindActionCreators({ closeTicket }, dispatch)),
);

export default decorate(CloseTicketPopup);